/*  MUI  */
import { Box } from '@mui/material';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { IconForSidebarListItem } from './SidebarIcons';
import { SidebarListItem } from './SidebarListItem';

/**
 * Component that renders the global menu items in the sidebar.
 * Displays a single menu item for global administration with a wrench icon.
 * Only accessible to users with 'partner' permission.
 * @returns JSX element containing the global menu items
 */
export const SidebarGlobalMenuItems = () => {
    const { t } = useTranslation();

    return (
        <Box
            data-testid="renderGlobalMenuItem"
            data-trackid="renderGlobalMenuItem"
            mb="4px"
            style={{ display: 'flex', flexDirection: 'column' }}
        >
            <SidebarListItem
                bottomItem
                icon={<IconForSidebarListItem src="BuildWrench" />}
                id="global_administration"
                name={t('Common.global_administration')}
                permission="partner"
                route="/globaladmin"
            />
        </Box>
    );
};
